import React from "react";
import { useSelector } from "react-redux";
import nagpur from "../../assets/documents/01} Nagpur Division SMP Competition Advertisment.pdf";
import corrigendumNagpur from "../../assets/documents/1-Corrigendum - SMP Competition for Nagpur Division.pdf";
import sambajinagar from "../../assets/documents/Chh. Sambajinagar Division SMP Competition Advertisment.pdf";
import nanded from "../../assets/documents/Nanded Division SMP Competition Advertisment.pdf";
import nashik from "../../assets/documents/NASHIK Division SMP Competition Advertisment.pdf";
import departmentRequirement from "../../assets/documents/Department Requirement Advertisement.pdf";
import { Link } from "react-router-dom";

const Advertisement = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    const content = {
        English: {
            title: "Advertisement",
            breadcrumb: {
                home: "HOME",
                page: "Advertisement",
            },
        },
        मराठी: {
            title: "जाहिरात",
            breadcrumb: {
                home: "मुख्यपृष्ठ ",
                page: "जाहिरात",
            },
        },
    };

    const t = content[selectedLang];

    const advertisements = [
        {
            titleEnglish: "01) Nagpur Division SMP Competition Advertisment",
            titleMarathi: "०१) नागपूर विभाग एसएमपी स्पर्धा जाहिरात",
            pdf: nagpur,
        },
        {
            titleEnglish: "02) Pune & Ratnagiri Division SMP Competition Advertisment",
            titleMarathi: "०२) पुणे व रत्नागिरी विभाग एसएमपी स्पर्धा जाहिरात",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSeS3Y0-itIPvN6Bdvp6la7YEjZfmzNwpTBzstYlnyz4m0sOHw/viewform",
        },
        {
            titleEnglish: "03) Nashik Division SMP Competition Advertisment",
            titleMarathi: "०३) नाशिक विभाग एसएमपी स्पर्धा जाहिरात",
            pdf: nashik,
        },
        {
            titleEnglish: "04) Chh. Sambajinagar Division SMP Competition Advertisment",
            titleMarathi: "०४) छत्रपती संभाजीनगर विभाग एसएमपी स्पर्धा जाहिरात",
            pdf: sambajinagar,
        },
        {
            titleEnglish: "05) Nanded Division SMP Competition Advertisment",
            titleMarathi: "०५) नांदेड विभाग एसएमपी स्पर्धा जाहिरात",
            pdf: nanded,
        },
        {
            titleEnglish: "Corrigendum - SMP Competition for Nagpur Division",
            titleMarathi: "शुद्धीपत्रक - नागपूर विभाग एसएमपी स्पर्धा",
            pdf: corrigendumNagpur,
        },
        {
            titleEnglish: "Corrigendum - SMP Competition for Sambajinagar Division.docx",
            titleMarathi:
                "शुद्धीपत्रक - संभाजीनगर विभाग एसएमपी स्पर्धा.docx",
            // pdf: corrigendumSambajinagar,
        },
    ];

    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
            <div className="mx-auto max-w-7xl">
                <div className="text-center mb-12">
                    <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                        {t.title}
                    </h1>
                    <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                        <span style={{ color: "#DD9827" }}>
                            <Link to="/" className="hover:underline">
                                {t.breadcrumb.home}
                            </Link>{" "}
                            /{" "}
                        </span>
                        {t.breadcrumb.page}
                    </p>
                </div>


                {/* Advertisement List */}
                <div className="space-y-4 pl-0 sm:pl-10 md:pl-20 lg:pl-40">
                    {advertisements.map((item, index) => (
                        <div key={index} className="flex items-center gap-3">
                            {/* Document Icon */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                className="shrink-0 text-gray-500"
                            >
                                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                                <path d="M14 2v6h6" />
                            </svg>

                            {item.pdf || item.link ? (
                                <a
                                    href={item.pdf || item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-base text-blue-600 hover:underline"
                                >
                                    {selectedLang === "मराठी"
                                        ? item.titleMarathi
                                        : item.titleEnglish}
                                </a>
                            ) : (
                                <span className="text-base text-blue-600">
                                    {selectedLang === "मराठी"
                                        ? item.titleMarathi
                                        : item.titleEnglish}
                                </span>
                            )}
                        </div>
                    ))}
                </div>

                {/* Separator */}
                <div className="mt-6 border-t border-gray-300" />

                {/* Department Requirement Advertisement */}
                <div className="mt-4 pl-0 sm:pl-10 md:pl-20 lg:pl-40">
                    <div className="flex items-center gap-3">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="shrink-0 text-gray-500"
                        >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                            <path d="M14 2v6h6" />
                        </svg>

                        <a
                            href={departmentRequirement}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-base text-blue-600 hover:underline"
                        >
                            {selectedLang === "मराठी"
                                ? "विभागाच्या आवश्यकतेसाठी जाहिरात"
                                : "Department Requirement Advertisement"}
                        </a>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Advertisement;